import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {Language} from 'src/app/services/languages.service';
import {InjectionToken} from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

export class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient, private url: string) {}

  // Must return Observable<any>
  getTranslation(lang: string): Observable<any> {
    return this.http.get(`${this.url}${lang}.json`);
  }
}

export function HttpTranslateFactory(http: HttpClient) {
  const clientId = localStorage.getItem('clientId') ?? '9000';

   const url = `${environment.langUrl}${clientId.slice(0, 4)}/`;


  return new CustomTranslateLoader(http, url);
}

export const LANG_SET = new InjectionToken<Language[]>('langSet');

export function LangSetResolveFactory(): Language[] {

     const clientId = localStorage.getItem('clientId') ?? '9000';

    switch (clientId.slice(0, 4)) {
       
        case '9121': {
            return [
                {id: 'da', name: 'denmark', lang: 'da_DK', code: 'DK'},
                {id: 'en', name: 'english', lang: 'en_GB', code: 'GB'},
            ];
        }
        case '9122': {
            return [
                {id: 'da', name: 'denmark', lang: 'da_DK', code: 'DK'},
                {id: 'en', name: 'english', lang: 'en_GB', code: 'GB'},
            ];
        }
        default: {
            return [
           
                {id: 'en', name: 'english', lang: 'en_GB', code: 'GB'},
            ];
        }
    }
}
